import { type } from "arktype";

import type { Reactive } from "vue";
export interface SignUpFormFields extends AuthBaseFormFields {
  firstName: string;
  lastName: string;
  confirmPassword: string;
  agreedWithPlatformTerms?: boolean;
}
export const SIGN_UP_VALIDATION_ERROR = {
  REQUIRED: "Это поле обязательное для заполнения",
  PASSWORD_CONFIRM: "Введенные пароли не совпадают",
  LENGTH_LESS: "Количество символов не должно быть меньше",
  LENGTH_LONG: "Количество символов не должно превышать",
} as const;

export const SIGN_UP_MAX_FIELD_LENGTH = 32;

export const passwordRegEx = /^[\s\S]{8,32}$/;
export const nameSurnameSchema = type({
  firstName: type("string").narrow((data, ctx) => {
    if (data.length > 0 && data.length <= SIGN_UP_MAX_FIELD_LENGTH) return true;

    if (data.length === 0) {
      return ctx.reject({
        message: SIGN_UP_VALIDATION_ERROR.REQUIRED,
        actual: "",
      });
    }

    return ctx.reject({
      message: `${SIGN_UP_VALIDATION_ERROR.LENGTH_LONG} ${SIGN_UP_MAX_FIELD_LENGTH} символа`,
      actual: "",
    });
  }),
  lastName: type("string").narrow((data, ctx) => {
    if (data.length > 0 && data.length <= SIGN_UP_MAX_FIELD_LENGTH) return true;

    if (data.length === 0) {
      return ctx.reject({
        message: SIGN_UP_VALIDATION_ERROR.REQUIRED,
        actual: "",
      });
    }

    return ctx.reject({
      message: `${SIGN_UP_VALIDATION_ERROR.LENGTH_LONG} ${SIGN_UP_MAX_FIELD_LENGTH} символа`,
      actual: "",
    });
  }),
});

export const useSignUp = () => {
  const signUpState: Reactive<SignUpFormFields> = reactive({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    agreedWithPlatformTerms: undefined,
  });

  const signUpSchema = computed(() =>
    type({
      agreedWithPlatformTerms: type("unknown").narrow((data, ctx) => {
        if (data === true) return true;

        return ctx.reject({
          message: SIGN_UP_VALIDATION_ERROR.REQUIRED,
          actual: "",
        });
      }),
      firstName: type("string").narrow((data, ctx) => {
        if (data.length > 0 && data.length <= SIGN_UP_MAX_FIELD_LENGTH)
          return true;

        if (data.length === 0) {
          return ctx.reject({
            message: SIGN_UP_VALIDATION_ERROR.REQUIRED,
            actual: "",
          });
        }

        return ctx.reject({
          message: `${SIGN_UP_VALIDATION_ERROR.LENGTH_LONG} ${SIGN_UP_MAX_FIELD_LENGTH} символа`,
          actual: "",
        });
      }),
      lastName: type("string").narrow((data, ctx) => {
        if (data.length > 0 && data.length <= SIGN_UP_MAX_FIELD_LENGTH)
          return true;

        if (data.length === 0) {
          return ctx.reject({
            message: SIGN_UP_VALIDATION_ERROR.REQUIRED,
            actual: "",
          });
        }

        return ctx.reject({
          message: `${SIGN_UP_VALIDATION_ERROR.LENGTH_LONG} ${SIGN_UP_MAX_FIELD_LENGTH} символа`,
          actual: "",
        });
      }),
      email: type("string.email").configure({
        message: "Невалидный адрес почты",
      }),
      password: type("string").narrow((data, ctx) => {
        if (passwordRegEx.test(data)) return true;

        return ctx.reject({
          message: "Минимум 8 символов",
          actual: "",
        });
      }),
      confirmPassword: type("string").narrow((data, ctx) => {
        if (data === (ctx.root as SignUpFormFields).password) return true;

        return ctx.reject({
          message: "Пароли не совпадают",
          actual: "",
        });
      }),
    }),
  );

  const submitForm = async (payload: SignUpFormFields) => {
    await $fetch("/api/v1/auth/sign-up", { body: payload, method: "POST" });
  };

  return {
    signUpSchema,
    signUpState,
    submitForm,
  };
};
